import styled from "styled-components";

import small_inventory_bg from "@assets/Background/small_inventory_bg.png";
import inventory_bg from "@assets/Background/inventory_bg.png";

interface IStyledVehicleItem {
    isAvailable?: boolean;
}
export const StyledVehicleView = styled.div`
    background-color: ${(p) => p.theme.colors.white02};
    min-height: 100vh;
    padding-bottom: 4rem;
    @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {

    }
    .vehicles {
        padding: 1rem 1rem;
        min-height: 80vh;
        @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
            padding: 2rem 2rem;
        }
        @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
            padding: 2rem 2rem;
        }
            margin-top:7rem;
            @media (max-width: ${(p) => p.theme.breakPoints.breakTablet}) {

            }
        .visible-pc {
            display: none;
            @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
                display: block;
            }
        }
        .visible-mobile {
            padding: "0 2rem";
            @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
                display: none;
            }
        }
        .activeCategory {
            color: ${(p) => p.theme.colors.white} !important;
            background-color: ${(p) => p.theme.colors.primary} !important;
        }
        &__top {
            text-align: left;
            @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
                margin-bottom: 2rem;
            }
            &-searchForm {
                height: 100%;
                display: flex;
                align-items: end;
                .MuiIconButton-root {
                    padding: 0rem 1rem;
                    @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
                        padding: 0rem 2rem;
                    }
                }
            }
        }
        &__content {
            padding-top: 2rem;
            @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
                border-top: 1px solid ${(p) => p.theme.colors.lightgray09};
            }
            @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                padding-top: 0;
            }
            .category {
                padding: 2rem;
                padding-top: 0;
                @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
                    padding-top: 0;
                    min-height: 77vh;
                    // border-right: 1px solid rgb(212, 212, 212);
                    padding-left: 0px;
                }
                @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                    padding: 0;
                }
                &__list {
                    text-align: center;
                    padding: 1.5rem 0;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
                    @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
                        text-align: center;
                    }
                }
                &__item {
                    cursor: pointer;
                    position: relative;
                    font-size: 1.6rem;
                    font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                    font-weight: 700;
                    color: ${(p) => p.theme.colors.darkBlack};
                    display: inline-block;
                    display: -webkit-box;
                    max-width: 100%;
                    /* height: 20px; */
                    line-height: 1.2;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: break-all;
                    width: fit-content;
                    text-align: center;
                    margin: 0 auto;
                    cursor: pointer;
                    &:after {
                        content: "";
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        left: 0;
                        top: 0;
                        background-color: transparent;
                    }
                }
                .listItem {
                    min-height: 75vh;
                }
            }
        }
    }
`;
export const StyledVehicleItem = styled.div<IStyledVehicleItem>`
    .wrapper {
        background-color: ${(p) => p.theme.colors.white00};
        padding: 1rem;
        border-radius: 6px;
        display: flex;
        position: relative;
        z-index: 1;
        justify-content: space-between;
        /* cursor: ${(p) => (p.isAvailable ? "pointer" : "no-drop")}; */
        /* cursor: pointer;
        &:before {
            content: "";
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background-color: ${(p) => p.theme.colors.gray4};
            opacity: 0.5;
            border-radius: 1.6rem;
            /* z-index: ${(p) => (p.isAvailable ? -1 : 2)};
        } */
        .wrapperImage {
            width: 9rem;
            height: 9rem;
            max-height: 9rem;

            // border: 2px solid ${(p) => p.theme.colors.gray3};
            // overflow: hidden;
            // width: 5rem;
            .image {
                // width: 100%;
                // height: 100%;
                width: 9rem;
                height: 9rem;
                object-fit:cover;
                border-radius: 6px;
            }
        }
        .wrapperContent {
            padding-left: 1rem;
            text-align: left;
            // width: 60%;
            .title {
                font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                font-weight: 700;
                font-size: 1.6rem;
                // padding-top: 1rem;
                // display: block;
                // display: -webkit-box;
                max-width: 100%;
                // line-height: 1.2;
                // -webkit-line-clamp: 2;
                // -webkit-box-orient: vertical;
                // overflow: hidden;
                // text-overflow: ellipsis;
                // word-break: break-all;
            }
        }
        .notAvailable {
            display: block;
            padding-top: 1rem;
            color: ${(p) => p.theme.colors.error};
            display: block;
            display: -webkit-box;
            max-width: 6rem;
            line-height: 1.2;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            height: 45px;
        }
    }
`;
export const StyledVehicleListItemComponent = styled.div`
    @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
        padding-left: 2.5rem;
    }
    .VehicleItems {
        &__content {
            @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                padding-top: 2rem;
            }
        }
        &__title {
            font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
            font-weight: 700;
            font-size: 1.6rem;
            padding: 2.5rem 0;
            text-align: left;
            display: block;
            height: 65px;
            display: -webkit-box;
            line-height: 1.2;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            max-width: 100%;
        }
        .error {
            min-height: 70vh;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
`;


export const StyledVehicleBorrowingCalendar = styled.div`
  background-color: ${(p) => p.theme.colors.white02};
  min-height: 100vh;
  text-align:start;
  padding: 90px 2rem 4rem 2rem;
  display:flex;
  flex-direction:column;

  @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
    90px 1rem 4rem 1rem;
  }

  .topTitle {
  
  @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
      padding-bottom:2rem;
      border-bottom: 1px solid ${(p) => p.theme.colors.lightgray09};
  }

  }

  .datePicker {
    margin-top:1rem;
    display:flex;
    align-items:center;
    gap:1rem;
  }


`;

export const StyledBorrowingCalendarContent = styled.div`
  border-radius: 6px;
  margin-top: 2rem;
  overflow: auto;
  position: relative;
  flex-grow: 1;
  min-height: 0;
  max-height: calc(98vh - 78px - 90px - 32px - 64px);
  @media (max-width: ${(p) => p.theme.breakPoints.breakTablet}) {
        max-height: calc(92vh - 78px - 90px - 32px - 64px);
    }
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

  table {
    width: 100%;
    border-spacing:0;
  }

  th, td {
    padding: 8px;
    @media (max-width: ${(p) => p.theme.breakPoints.breakTablet}) {
        padding:4px;
    }
    text-align: center;
    font-weight: normal;
    color: ${(p) => p.theme.colors.black01};
    white-space: nowrap;
    box-sizing:border-box;
    overflow:hidden;
    text-overflow:ellipsis;
    vertical-align:top;
  }

  th {
    padding-top:4px;
    padding-bottom:4px;
    }

  thead {
    position: sticky;
    top: 0;
    z-index: 4;
    box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.15);
    -webkit-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.15);
    -moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.15);
  }


  thead th {
    position: sticky;
    top: 0;
    text-overflow:ellipsis;
    background-color: ${(p) => p.theme.colors.lightgray09};
    z-index:5;
    border-bottom:1px solid ${(p) => p.theme.colors.gray03};
    font-weight:bold;
}


  .leftSticky {
    position: sticky;
    z-index: 2;
    background-color: ${(p) => p.theme.colors.white00};
    font-size:14px;
    @media (max-width: ${(p) => p.theme.breakPoints.breakTablet}) {
        font-size:12px;
    }
  }


  thead th.leftSticky {
    position:sticky;
    top:0;
    z-index: 6;
    background-color: ${(p) => p.theme.colors.lightgray09};
  }

  td.leftSticky:nth-child(1),
  thead th.leftSticky:nth-child(1) {
    left: 0;
    min-width: 60px;
    max-width: 60px;
    width: 60px;
    @media (max-width: ${(p) => p.theme.breakPoints.breakTablet}) {
        min-width: 40px;
        max-width: 40px;
        width: 40px;
    }
  }

  td.leftSticky:nth-child(1) {
    border-bottom:1px solid ${(p) => p.theme.colors.lightgray09};
    border-right:1px solid ${(p) => p.theme.colors.lightgray09};
  }

  td.leftSticky:nth-child(2),
  thead th.leftSticky:nth-child(2) {
    left: 60px;
    width: 250px;
    min-width: 250px;
    @media (max-width: ${(p) => p.theme.breakPoints.breakTablet}) {
        left:40px;
        min-width: 100px;
        width: 100px;
    }
  }

  td.leftSticky:nth-child(2) {
    white-space: normal; 
    overflow: visible;   
    text-overflow: clip;  
    text-align: left;  
    vertical-align: middle;
    border-bottom:1px solid ${(p) => p.theme.colors.lightgray09};
    border-right:1px solid ${(p) => p.theme.colors.gray03};
  }

   thead th.leftSticky:nth-child(2) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    border-right:1px solid ${(p) => p.theme.colors.gray03};
  }

  thead th.leftSticky:nth-child(1) {
    border-right: none;
  }

 
  .table__event {
    padding: 0;
    margin: 0;
    position: relative;
    vertical-align: top;
  }

  .eventContainer {
    background-color: ${(p) => p.theme.colors.lightgray09};
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    box-shadow: inset 0 0 0 1px ${(p) => p.theme.colors.white00};
  }



  .eventContainer .event,
  .eventContainer .eventRed {
    color: #fff;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .eventContainer .event {
    background-color: ${(p) => p.theme.colors.blue06};
    border:1px solid ${(p) => p.theme.colors.white00};
  }

  .eventContainer .eventRed {
    background-color: ${(p) => p.theme.colors.red05};
    border:1px solid ${(p) => p.theme.colors.white00};
  }

  th.day,
  td.day,
  th.dayOff,
  td.dayOff{
      width: 40px;
      min-width: 40px;
      max-width: 40px;
      overflow: visible;
      text-overflow: ellipsis;
  }

  th.dayOff,
  td.dayOff {
    background-color: ${(p) => p.theme.colors.red05};
    color: ${(p) => p.theme.colors.white00};
    
  }

  th.day,
  th.dayOff {
  border-right:1px solid ${(p) => p.theme.colors.white00};
  border-left:1px solid ${(p) => p.theme.colors.white00};
}

  thead th.dayOff {
     background-color: ${(p) => p.theme.colors.red05};
  }

  .empty {
    height: 42px;
  }

  .eventBlue {
    height: 42px;
    background-color: ${(p) => p.theme.colors.blue06};
  }

  .eventRed {
    height: 42px;
    background-color: ${(p) => p.theme.colors.red05};
  }

  .delay {
    border-radius: 6px;
    padding: 5px 0; /* Adjusted padding */
    color: ${(p) => p.theme.colors.white00};
    font-weight: bold;
    background-color: ${(p) => p.theme.colors.red05};
    display: inline-block; 
    width: 100%; 
    box-sizing: border-box;
  }
`;

